var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FF6E6E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8335 31.8333H26.2335C24.9267 31.8333 24.2733 31.8333 23.7742 32.0877C23.3351 32.3114 22.9782 32.6683 22.7545 33.1074C22.5002 33.6065 22.5002 34.2599 22.5002 35.5667V43.5M43.5002 43.5V26.2333C43.5002 24.9265 43.5002 24.2731 43.2458 23.774C43.0221 23.335 42.6652 22.978 42.2261 22.7543C41.727 22.5 41.0736 22.5 39.7668 22.5H35.5668C34.26 22.5 33.6066 22.5 33.1075 22.7543C32.6685 22.978 32.3115 23.335 32.0878 23.774C31.8335 24.2731 31.8335 24.9265 31.8335 26.2333V43.5M44.6668 43.5H21.3335M35.9168 27.1667H39.4168M35.9168 31.8333H39.4168M35.9168 36.5H39.4168",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#FECDD6",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/Experience.beddc9b3c5d87b63452c446ac402649f.svg";
export { ForwardRef as ReactComponent };